import React from 'react';
import { connect } from 'react-redux';
import { jsx, css } from '@emotion/core';
import { primary_s5_l70 } from '../lib/colors';

const getStyles = (primaryColor, uiVariantInputText) => css`
  .form-control {
    border-radius: ${uiVariantInputText === '1'
      ? '12px'
      : uiVariantInputText === '3'
      ? '30px'
      : 0};

    &:focus {
      border-color: ${primaryColor};
    }
  }
  .help-block {
    color: ${primary_s5_l70(primaryColor)};
  }
`;

const TextField = props => {
  const {
    input,
    label,
    type,
    rows = 5,
    meta: { asyncValidating, touched, error },
    primaryColor,
    uiVariantInputText,
  } = props;
  return (
    <div
      css={getStyles(primaryColor, uiVariantInputText)}
      className={`form-group ${touched && error && 'error'} ${
        asyncValidating ? 'async-validating' : ''
      }`}
    >
      {type === 'textarea' ? (
        <textarea
          {...input}
          placeholder={label}
          rows={rows}
          className="form-control"
          style={
            label === 'provider' || label === 'providerId'
              ? { display: 'none' }
              : null
          }
        />
      ) : (
        <input
          {...input}
          placeholder={label}
          type={type}
          className="form-control"
          style={
            label === 'provider' || label === 'providerId'
              ? { display: 'none' }
              : null
          }
        />
      )}
      {touched && error && <div className="error-text">{error}</div>}
    </div>
  );
};

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantInputText: state.store.data.uiVariants.inputText,
});

export default connect(mapStateToProps)(TextField);
